import { NO_ELEMENT, rm } from 'utils';
import styles from './relatedArticles.scss';

interface RelatedArticlesProps {
  articles: {
    url: string;
    image: string;
    title: string;
    text: string;
  }[];
}

const isRelatedArticles = (props: unknown): props is RelatedArticlesProps =>
  'articles' in (props as RelatedArticlesProps);

export const RelatedArticles = (props: unknown) => {
  if (!isRelatedArticles(props)) {
    return NO_ELEMENT;
  }

  return (
    <div className={styles.relatedArticles}>
      <h2 className={styles.heading}>{rm('kb_area_related_header')}</h2>
      <div className={styles.articles}>
        {props.articles.map(({ url, image, title, text }) => (
          <div key={url} className={styles.article}>
            <div className={styles.image} style={{ backgroundImage: `url(${image})` }} />
            <div className={styles.content}>
              <h3 className={styles.title}>{title}</h3>
              <p className={styles.text}>{text}</p>
              <a className={styles.button} href={url}>
                {rm('kb_relatedArticles_readMore')}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
